/* SeraLash · regalos del carrito.
   Mantiene las líneas de regalo a $0 acordes con los kits que hay en el carrito:
   envío gratis y garantía con 1 kit o más; tarjeta de regalo con 2 kits o más (y como máximo
   CFG.tarjetaMax kits) mientras dure la oferta. Sin kits no queda ningún regalo.
   Shipping Protection (opcional, la añade el cliente): como máximo 1 y se quita si no quedan kits.
   4.º kit complemento ($349): solo con 3 kits o más en el carrito y como máximo 1. */
window.SLEXTRA = { handle: 'seralash-4-kit-complemento', productoId: 11050894360915 };
(function () {
  if (window.SLCart) return;
  var CFG = window.SLCFG || {}, R = CFG.regalos || {}, nativo = window.fetch.bind(window);
  var enCurso = null, maxT = CFG.tarjetaMax || 99, EX = window.SLEXTRA;

  function tarjetaActiva() {
    var fin = CFG.fin ? Date.parse(CFG.fin) : NaN;
    return CFG.tarjeta > 0 && R.tarjeta && (isNaN(fin) || fin > Date.now()) && CFG.tarjetasQuedan !== '0';
  }

  function reconciliar() {
    if (enCurso) return enCurso;
    enCurso = nativo('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var kits = 0, hay = {}, extras = [];
        cart.items.forEach(function (it) {
          if (it.product_id === CFG.productoId) kits += it.quantity;
          if (it.product_id === EX.productoId) extras.push(it);
          hay[it.variant_id] = (hay[it.variant_id] || 0) + it.quantity;
        });
        var quiero = {};
        if (R.envio) quiero[R.envio] = kits >= 1 ? 1 : 0;
        if (R.garantia) quiero[R.garantia] = kits >= 1 ? 1 : 0;
        if (R.tarjeta) quiero[R.tarjeta] = kits >= 2 && kits <= maxT && tarjetaActiva() ? 1 : 0;
        if (CFG.proteccion && hay[CFG.proteccion]) quiero[CFG.proteccion] = kits >= 1 ? 1 : 0;
        /* 4.º kit: máximo 1 unidad en total y solo con 3 kits o más. */
        var resto = kits >= 3 ? 1 : 0;
        extras.forEach(function (it) { var q = Math.min(hay[it.variant_id], resto); quiero[it.variant_id] = q; resto -= q; });
        var cambios = {}, n = 0;
        Object.keys(quiero).forEach(function (id) {
          if ((hay[id] || 0) !== quiero[id]) { cambios[id] = quiero[id]; n++; }
        });
        if (!n) return false;
        return nativo('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: cambios })
        }).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (cambio) { enCurso = null; return cambio; });
    return enCurso;
  }

  /* Cualquier cambio de carrito hecho por la página espera a que los regalos queden al día. */
  window.fetch = function (entrada) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var p = nativo.apply(null, arguments);
    if (!/\/cart\/(add|change|update|clear)/.test(url)) return p;
    return p.then(function (resp) {
      return reconciliar().then(function () { return resp; }, function () { return resp; });
    });
  };

  window.SLCart = { reconciliar: reconciliar };

  /* Al cargar cualquier página: si el carrito no cuadra, se corrige; en la página del carrito se recarga para mostrarlo. */
  reconciliar().then(function (cambio) {
    if (cambio && CFG.cartUrl && location.pathname.replace(/\/$/, '') === CFG.cartUrl.replace(/\/$/, '')) location.reload();
  });
})();

/* Oferta del 4.º kit en la página del carrito: aparece con 3 kits o más y sin el 4.º kit añadido. */
(function () {
  var raiz = document.querySelector('.sl-carrito'); if (!raiz) return;
  var pie = raiz.querySelector('.sl-carrito-pie'); if (!pie) return;
  var CFG = window.SLCFG || {}, EX = window.SLEXTRA, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  Promise.all([
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
    fetch(root + 'products/' + EX.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
  ]).then(function (res) {
    var cart = res[0], prod = res[1], kits = 0, tiene = false;
    cart.items.forEach(function (it) { if (it.product_id === CFG.productoId) kits += it.quantity; if (it.product_id === EX.productoId) tiene = true; });
    if (kits < 3 || tiene || !prod.available) return;
    var vs = prod.variants.filter(function (v) { return v.available; }); if (!vs.length) return;
    var cur = cart.currency || 'MXN';
    function din(c) { if (cur === 'MXN') { var d = c % 100 ? 2 : 0; return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }); } return new Intl.NumberFormat('es', { style: 'currency', currency: cur }).format(c / 100); }
    var p = vs[0].price, reg = vs[0].compare_at_price || 0, sel = vs[0].id;
    var c = document.createElement('div');
    c.className = 'sl-extra';
    c.innerHTML = '<div class="sl-extra-top"><span class="sl-extra-tag">SOLO EN TU CARRITO</span><b>Añade un 4.º estilo por ' + din(p) + '</b>' +
      (reg > p ? '<span class="sl-extra-reg">Precio normal <s>' + din(reg) + '</s> · ahorras ' + din(reg - p) + '</span>' : '') + '</div>' +
      '<div class="sl-extra-est" role="group" aria-label="Elige el estilo">' + vs.map(function (v, i) { return '<button type="button" class="sl-pill" data-ex="' + v.id + '" aria-pressed="' + (i === 0) + '">' + v.title + '</button>'; }).join('') + '</div>' +
      '<button type="button" class="sl-cta sl-cta-rosa sl-extra-btn">Añadir 4.º kit · ' + din(p) + '</button>' +
      '<p class="sl-prot-err" hidden>No pudimos añadirlo. Inténtalo de nuevo.</p>';
    pie.before(c);
    var st = document.createElement('style');
    st.textContent = '.sl-extra{max-width:560px;margin:0 auto 18px;padding:0 16px}' +
      '.sl-extra>*{box-sizing:border-box}' +
      '.sl-extra{display:grid;gap:12px}' +
      '.sl-extra-top{display:grid;gap:4px;justify-items:start;background:#FDEEF2;border:1.5px solid #F3C6D2;border-radius:14px;padding:14px 16px}' +
      '.sl-extra-tag{font:700 11px var(--sl-d);letter-spacing:.08em;color:#fff;background:var(--sl-rosa-int,#D14D6E);border-radius:999px;padding:4px 10px}' +
      '.sl-extra-top b{font:700 18px/1.25 var(--sl-d)}' +
      '.sl-extra-reg{font-size:13.5px;color:var(--sl-gris,#666)}' +
      '.sl-extra-est{display:flex;flex-wrap:wrap;gap:8px}' +
      '.sl-extra .sl-pill{border:1.5px solid var(--sl-borde,#ddd);background:#fff;border-radius:999px;padding:8px 14px;font:600 14px var(--sl-d);cursor:pointer}' +
      '.sl-extra .sl-pill[aria-pressed=true]{border-color:var(--sl-rosa-int,#D14D6E);background:#FDEEF2;color:var(--sl-rosa-int,#D14D6E)}' +
      '.sl-extra .sl-extra-btn{margin:0;width:100%}.sl-extra .sl-extra-btn:disabled{opacity:.6}';
    document.head.appendChild(st);
    c.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.ex) { sel = Number(b.dataset.ex); c.querySelectorAll('[data-ex]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); return; }
      if (!b.classList.contains('sl-extra-btn')) return;
      var err = c.querySelector('.sl-prot-err');
      b.disabled = true; err.hidden = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: sel, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.reload(); })
        .catch(function () { b.disabled = false; err.hidden = false; });
    });
  }).catch(function () {});
})();

/* Aviso para el navegador interno de Instagram / Facebook: el pago con tarjeta (verificación del banco) puede fallar ahí.
   Solo se muestra en ese navegador. Para verlo en pruebas: añade ?iab=1 a la URL del carrito. */
(function () {
  var ua = navigator.userAgent || '';
  var iab = /Instagram|FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) || /[?&]iab=1/.test(location.search);
  if (!iab) return;
  function pinta() {
    var btn = document.querySelector('.sl-carrito-pie form button[name="checkout"]');
    if (!btn || document.querySelector('.sl-iab')) return;
    var esIG = /Instagram/i.test(ua);
    var d = document.createElement('div');
    d.className = 'sl-iab';
    d.setAttribute('role', 'note');
    d.innerHTML = '<span class="sl-iab-ic" aria-hidden="true">i</span><p><b>¿Problemas al pagar?</b> Toca <b>⋯</b> arriba a la derecha y elige <b>«Abrir en el navegador»</b>' + (esIG ? '' : ' (o «Abrir en Safari / Chrome»)') + '. Tu carrito se mantiene.</p>';
    btn.closest('form').before(d);
    var st = document.createElement('style');
    st.textContent = '.sl-iab{display:flex;gap:10px;align-items:flex-start;background:#fff;border:1.5px solid var(--sl-rosa,#D14D6E);border-radius:12px;padding:11px 13px;margin:4px 0 12px;text-align:left}' +
      '.sl-iab p{margin:0;font-size:13.5px;line-height:1.4;color:#333}' +
      '.sl-iab-ic{flex:none;width:22px;height:22px;border-radius:50%;background:var(--sl-rosa-int,#D14D6E);color:#fff;font:700 13px/22px Georgia,serif;text-align:center;font-style:italic}';
    document.head.appendChild(st);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinta); else pinta();
})();
